'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _autocomplete = require('../actions/autocomplete');

var _autocomplete2 = require('../transformers/autocomplete');

var EMPTY_LIST = [];

var INITIAL_STATE = {
	directory: EMPTY_LIST,
	healthChecks: EMPTY_LIST,
	scans: EMPTY_LIST,
	location: EMPTY_LIST,
	usingNearMe: false,
	findingLocation: false
};

var autocomplete = function autocomplete(state, action) {
	switch (action.type) {
		case _autocomplete.DIRECTORY + '_RECEIVED':
			return Object.assign({}, state, { directory: action.response || EMPTY_LIST });
		case _autocomplete.CLEAR_DIRECTORY:
			return Object.assign({}, state, { directory: EMPTY_LIST });
		case _autocomplete.HEALTH_CHECKS + '_RECEIVED':
			return Object.assign({}, state, { healthChecks: action.response && action.response.length && (0, _autocomplete2.transformHealthChecksScans)(action.response, 'healthCheck') || EMPTY_LIST });
		case _autocomplete.CLEAR_HEALTH_CHECKS:
			return Object.assign({}, state, { healthChecks: EMPTY_LIST });
		case _autocomplete.SCANS + '_RECEIVED':
			return Object.assign({}, state, { scans: action.response && action.response.length && (0, _autocomplete2.transformHealthChecksScans)(action.response, 'scan') || EMPTY_LIST });
		case _autocomplete.CLEAR_SCANS:
			return Object.assign({}, state, { scans: EMPTY_LIST });
		case _autocomplete.LOCATION + '_RECEIVED':
			return Object.assign({}, state, { location: action.response });
		case _autocomplete.LOCATION + '_FAILED':
			return Object.assign({}, state, { location: EMPTY_LIST });
		case _autocomplete.CLEAR_LOCATION:
			return Object.assign({}, state, { location: EMPTY_LIST });
		case _autocomplete.LOCATION_NEAR_ME + '_REQUESTED':
			return Object.assign({}, state, { usingNearMe: true, findingLocation: true });
		case _autocomplete.LOCATION_NEAR_ME + '_RECEIVED':
			return Object.assign({}, state, { findingLocation: false, location_search_center: action.position.coords });
		case _autocomplete.LOCATION_NEAR_ME + '_FAILED':
			return Object.assign({}, state, { findingLocation: false, usingNearMe: false });
		case _autocomplete.CLEAR_LOCATION_NEAR_ME:
			return Object.assign({}, state, { findingLocation: false, usingNearMe: false, location_search_center: null });
		case '@@router/LOCATION_CHANGE':
			return action.payload && action.payload.pathname && action.payload.pathname === '/' ? Object.assign({}, state, INITIAL_STATE) : state;
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = autocomplete;